import axios from 'axios';
import firebase from "firebase/app";
import "firebase/auth";

const getCustomData = () => {
  const userId = firebase.auth().currentUser?.uid;
  return {
    userId
  };
};

const backendURL = import.meta.env.VITE_BACKEND_URL || 'http://localhost:5001';

const api = axios.create({
  baseURL: `${backendURL}`,
  // timeout: 5000,
});

api.interceptors.request.use(
  async config => {
    const customData = getCustomData();
    if (customData) {
      config.headers['X-Custom-Header'] = JSON.stringify(customData);
    }
    
    // Add Firebase auth token for authenticated requests
    try {
      const user = firebase.auth().currentUser;
      if (user) {
        const token = await user.getIdToken();
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    } catch (error) {
      console.warn('Failed to get Firebase auth token:', error);
    }
    
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// New axios instance for job and CV features (Google Cloud service)
const jobCvAPI = axios.create({
  baseURL: import.meta.env.VITE_GOOGLE_CLOUD_API_URL || 'http://localhost:3003',
  // timeout: 10000, // Longer timeout for CV/job processing
});

jobCvAPI.interceptors.request.use(
  async config => {
    const customData = getCustomData();
    if (customData) {
      config.headers['X-Custom-Header'] = JSON.stringify(customData);
    }
    
    // Add Firebase auth token for authenticated requests
    try {
      const user = firebase.auth().currentUser;
      if (user) {
        const token = await user.getIdToken();
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    } catch (error) {
      console.warn('Failed to get Firebase auth token:', error);
    }
    
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default api;
export { jobCvAPI };
